import Controller from '../abstracts/Controller';
import 'scss-templates/t-editorial-page.scss';

export default class EditorialPageController extends Controller {
  static get COMPONENTS() {
    return [
      'AddToWishlistComponent',
      'EditorialComponent',
      'FidelityRewardComponent',
      'WishlistComponent',
      'CountdownComponent',
      'ShopCategoryComponent',
      'CarouselModuleComponent',
    ];
  }
}
